<div class="w-full">
  <!-- Loading Spinner -->
  <ng-container *ngIf="isLoadingData; else additionalInfo">
    <div class="flex gap-4 align-items-center justify-content-center py-5">
      <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)"
        animationDuration=".5s">
      </p-progressSpinner>
    </div>
  </ng-container>

  <ng-template #additionalInfo>
      <p-tabView styleClass="tab_style">
      <!-- Pending Tasks -->
      <p-tabPanel header="Pending Tasks">
        <div class="w-full flex flex-column gap-3">
          <h2 class="w-full text-left font-medium text-xl text-dark">Pending Tasks</h2>
          <div class="w-full flex flex-column gap-2">
            <div *ngFor="let item of pendingQuestions?.additionalInfo; let i = index"
              class="w-full flex gap-3 p-3 border-round-lg bg-white">
              <div class="w-full flex gap-2">
                <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                  <img [src]="item.mentorImage || '../../../assets/images/avatar1.jpg'" alt="Mentor"
                    class="w-full h-full object-cover">
                </div>
                <div class="w-full flex flex-column gap-2">
                  <div class="relative w-full p-2 border-round-md" [style.background-color]="item.colourCode || '#e9ecef'">
                    <p class="text-left font-normal text-base text-dark" [style.color]="item.colourCode === '#12263F' || item.colourCode === '#000086' ? '#fff' : 'inherit'">{{ item.question }}</p>
                    <p-button (onClick)="showDialog(item.id)" icon="pi pi-pencil" styleClass="updateIcon"
                    ></p-button>
                  </div>
                  <p-button *ngIf="item.requestedAttachment" label="Attachment" icon="pi pi-paperclip" styleClass="attach_ment"
                          (onClick)="openAttachment(item.requestedAttachment)" />
                  <small class="w-full block text-left text-secondary text-sm">{{item.createdOn | date: 'MMM dd, yyyy'
                    }}</small>
                </div>
              </div>
              <!-- <div class="">
                <p-button (onClick)="showDialog(item.id)" icon="pi pi-pencil"
                  styleClass="updateIcon"></p-button>
              </div> -->
            </div>
          </div>
        </div>
      </p-tabPanel>

      <!-- Resolved Tasks -->
      <p-tabPanel header="Resolved Tasks">
        <div class="w-full flex flex-column gap-3">
          <h2 class="w-full text-left font-medium text-xl text-dark">Resolved Tasks</h2>
          <div class="w-full flex flex-column gap-2">
            <div *ngFor="let item of resolvedQuestions?.additionalInfo"
              class="w-full flex flex-column gap-3 p-3 border-round-lg bg-white">
              <div class="w-full flex gap-2 pr-8">
                <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                  <img [src]="item.mentorImage || '../../../assets/images/avatar1.jpg'" alt="Mentor"
                    class="w-full h-full object-cover">
                </div>
                <div class="w-full flex flex-column gap-2">
                  <div class="w-full p-2 border-round-md" [style.background-color]="item.colourCode || '#e9ecef'">
                    <b class="w-full block text-left font-medium mb-1"
                      [style.color]="item.colourCode === '#12263F' || item.colourCode === '#000086' ? '#fff' : '#111111'"
                      style="font-size: 17px;">{{item.mentorName}}</b>
                    <p class="text-left font-normal text-base text-dark" [style.color]="item.colourCode === '#12263F' || item.colourCode === '#000086' ? '#fff' : 'inherit'">{{ item.question }}</p>
                  </div>
                  <p-button *ngIf="item.requestedAttachment" label="Attachment" icon="pi pi-paperclip" styleClass="attach_ment"
                  (onClick)="openAttachment(item.requestedAttachment)" />
                  <small class="w-full block text-left text-secondary text-sm">{{item.createdOn | date: 'MMM dd, yyyy'
                    }}</small>
                </div>
              </div>
              <div class="w-full flex gap-2 pl-8">
                <div class="w-full flex flex-column gap-2">
                  <div class="w-full flex flex-column gap-2 p-2 bg-yellow-100 border-round-md">
                    <b class="w-full block text-right font-medium text-lg text-dark mb-1">
                      {{ resolvedQuestions?.studentDetails?.studentName || 'Student' }}
                    </b>
                    <p class="text-right font-normal text-base text-gray-700">{{ item.reply }}</p>
                  </div>
                  <div class="w-full flex align-items-center justify-content-between">
                    <p-button *ngIf="item.attachementSAS" label="Attachment" icon="pi pi-paperclip"
                      styleClass="attach_ment" (onClick)="openAttachment(item.attachementSAS)" />
                    <small class="w-auto inline-block text-left text-secondary text-sm">{{item.updatedOn | date: 'MMM dd, yyyy' }}</small>
                  </div>
                </div>
                <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                  <img [src]="resolvedQuestions?.studentDetails?.imageUrl || '../../../assets/images/avatar1.jpg'"
                    alt="Student" class="w-full h-full object-cover">
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <!-- General Tasks -->
      <!-- <p-tabPanel header="General Tasks">
        <div class="w-full flex flex-column gap-3">
          <h2 class="w-full text-left font-medium text-xl text-dark">General Tasks</h2>
          <div class="w-full flex flex-column gap-2">
            <div *ngFor="let item of resolvedQuestions?.additionalInfo"
              class="w-full flex flex-column gap-3 p-3 border-round-lg bg-white">
              <div class="w-full flex gap-2 pr-8">
                <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                  <img [src]="item.mentorImage || '../../../assets/images/avatar1.jpg'" alt="Mentor"
                    class="w-full h-full object-cover">
                </div>
                <div class="w-full flex flex-column gap-2">
                  <div class="w-full p-2 bg-gray-200 border-round-md">
                    <b class="w-full block text-left font-medium mb-1"
                      style="font-size: 17px; color: #111111;">{{item.mentorName}}</b>
                    <p class="text-left font-normal text-base text-dark">{{ item.question }}</p>
                  </div>
                  <small class="w-full block text-left text-secondary text-sm">{{item.createdOn | date: 'MMM dd, yyyy'
                    }}</small>
                </div>
              </div>
              <div class="w-full flex gap-2 pl-8">
                <div class="w-full flex flex-column gap-2">
                  <div class="w-full flex flex-column gap-2 p-2 bg-yellow-100 border-round-md">
                    <b class="w-full block text-right font-medium text-lg text-dark mb-1">
                      {{ resolvedQuestions?.studentDetails?.studentName || 'Student' }}
                    </b>
                    <p class="text-right font-normal text-base text-gray-700">{{ item.reply }}</p>
                  </div>
                  <div class="w-full flex align-items-center justify-content-between">
                    <p-button *ngIf="item.attachementSAS" label="Attachment" icon="pi pi-paperclip"
                      styleClass="attach_ment" (onClick)="openAttachment(item.attachementSAS)" />
                    <small class="w-auto inline-block text-left text-secondary text-sm">{{item.updatedOn | date: 'MMM dd, yyyy' }}</small>
                  </div>
                </div>
                <div class="w-3rem h-3rem border-circle overflow-hidden flex-shrink-0">
                  <img [src]="resolvedQuestions?.studentDetails?.imageUrl || '../../../assets/images/avatar1.jpg'"
                    alt="Student" class="w-full h-full object-cover">
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel> -->
    </p-tabView>
  </ng-template>
</div>

<p-dialog header="Task" [modal]="true" [(visible)]="visible" [style]="{ width: '40rem' }">

  <div class="flex flex-column align-items-center gap-2 mb-4">
    <div class="w-full flex align-items-center justify-content-between">
      <b class="font-normal">Add Task</b>
      <p-button label={{currentProfileSection}} styleClass="pop_btn" />
    </div>
    <form class="w-full" [formGroup]="additionalInformationForm" (ngSubmit)="onUpdate()">
      <div class="w-full mb-2 flex flex-column gap-2 ">
        <label for="startDate">Start Date and Time</label>
        <p-calendar
        inputId="startDate"
        appendTo = "body"

        formControlName="startDate"
        [showTime]="true"
        [style]="{ width: '100%' }"
          [inputStyle]="{ width: '100%' }"

        [hourFormat]="'12'" />
        <small class="text-red-500 block" *ngIf="additionalInformationForm.get('startDate')?.invalid &&
             (submitted || additionalInformationForm.get('startDate')?.touched)">
            Start Date and Time is required
        </small>
      </div>
      <div class="w-full mb-2 flex flex-column gap-2 ">
        <label for="dueDate">End Date and Time</label>
        <p-calendar
        inputId="dueDate"
        appendTo = "body"

        formControlName="dueDate"
        [showTime]="true"
        [style]="{ width: '100%' }"
          [inputStyle]="{ width: '100%' }"

        [hourFormat]="'12'" />
        <small class="text-red-500 block" *ngIf="additionalInformationForm.get('dueDate')?.invalid &&
             (submitted || additionalInformationForm.get('dueDate')?.touched)">
            End Date and Time is required
        </small>
      </div>

      <div class="flex flex-column gap-3">
          <textarea class="w-full" style="border: 1px solid #CCD7E7; border-radius: 4px; padding: 8px; box-sizing: border-box;"
            rows="5"
            cols="30"
            pInputTextarea
            formControlName = "additionalInfo" >
          </textarea>
          <small class="text-red-500 block" *ngIf="additionalInformationForm.get('additionalInfo')?.invalid &&
                      (submitted || additionalInformationForm.get('additionalInfo')?.touched)">
            Information is required
          </small>
          <div class="flex flex-column gap-2 mt-2">
            <label class="font-medium text-sm">Choose Priority Color</label>
            <div class="flex flex-wrap gap-3 mt-1">
              <div *ngFor="let color of brandColors"
                   (click)="onColorSelect(color)"
                   [style.background-color]="color"
                   class="w-2rem h-2rem border-circle cursor-pointer transition-all transition-duration-200 hover:scale-110 shadow-1"
                   [style.border]="selectedColor === color ? '3px solid #fff' : '1px solid #dee2e6'"
                   [style.outline]="selectedColor === color ? '2px solid ' + color : 'none'"
                   [title]="color">
              </div>
            </div>
            <small class="text-gray-500 text-xs">Selected color will be used for task identification.</small>
          </div>
          <div class="w-full text-center">
          </div>
          <div class="flex align-items-center gap-2 ">
            <p-fileUpload styleClass="fileupload" #fileUploader mode="basic" name="demo[]" chooseIcon="pi pi-upload"
            url="https://www.primefaces.org/cdn/api/upload.php" accept=".pdf,.doc,.docx,image/*" maxFileSize="1000000" fileLimit="1"
            (onSelect)="onFileSelect($event)" [auto]="false" chooseLabel="Browse" (filesRemoved)="onFileRemoved()"
            />
            <p-button  class="font-regular"
              (onClick)="onFileRemoved()"
              icon="pi pi-times"
              styleClass="closeIcon"
              [rounded]="true"
              appendTo="body"
              pTooltip="Clear image"
              tooltipPosition="top"
            />
          </div>
          <p-button label="Submit" [loading]="isLoading" class="mt-3" styleClass="save_btn1" type="submit"/>
      </div>

    </form>
    </div>

</p-dialog>
